import axios from 'axios';

import { handleError } from './utils';

export type FirebaseConfig = {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId?: string;
};
export const getFirebaseConfig = async (
    basepath = '/api',
): Promise<FirebaseConfig> => {
    try {
        const response = await axios.get(`${basepath}/firebaseConfig`);
        const data = response.data;
        return {
            apiKey: data.api_key,
            authDomain: data.auth_domain,
            projectId: data.project_id,
            storageBucket: data.storage_bucket,
            messagingSenderId: data.messaging_sender_id,
            appId: data.app_id,
            measurementId: data.measurement_id,
        };
    } catch (e) {
        handleError("Couldn't fetch firebase config", e);
        return {} as FirebaseConfig;
    }
};
